import type { RefreshTokenCallback } from "@lumi/data";

/**
 * Creates a refresh callback function for use with authenticatedFetch.
 * This callback attempts to refresh the access token and returns the new token if successful.
 *
 * @param refreshAuth - The refresh function from AuthContext
 * @returns A RefreshTokenCallback that can be passed to authenticatedFetch
 */
export function createRefreshCallback(refreshAuth: () => Promise<boolean>): RefreshTokenCallback {
  return async () => {
    console.log("createRefreshCallback: Starting token refresh...");
    const success = await refreshAuth();
    console.log("createRefreshCallback: Refresh result:", success);

    if (success) {
      const newToken = localStorage.getItem("lumi-access-token");
      console.log(
        "createRefreshCallback: New token from localStorage:",
        newToken ? `${newToken.slice(0, 20)}...` : "null",
      );
      return newToken ? { accessToken: newToken } : null;
    }

    console.log("createRefreshCallback: Refresh failed, returning null");
    return null;
  };
}
